import React from 'react';
import experimentState, {ApplicationState} from "./state/experimentState"
import Message from "./message"
import {observer} from "mobx-react"
import $ from 'jquery';
import backend from "./backend";

const MessagesView = observer(
    class extends React.Component {

        timeout = 8

        constructor(props) {
            super(props);

            this.state = {
                now: performance.now()
            }
        }

        componentDidMount() {
            this.scrollToBottom();
            this.intervalId = setInterval(() => this.updateClock(),100)
        }

        componentDidUpdate() {
            this.scrollToBottom();
        }

        componentWillUnmount() {
            clearInterval(this.intervalId)
        }

        updateClock() {
            let now = performance.now()
            if (!experimentState.questionExpired && experimentState.questionStart && experimentState.questionStart + (this.timeout * 1000) < now) {
                    // experimentState.setQuestionStart(null)
                    experimentState.setQuestionExpired(true)
                    console.log("Question expired!!!")
                    // question timed out
                    backend.actionSendQuestionFinish(true)
            }
            this.setState({
                now: performance.now()
            })
        }

        scrollToBottom() {
            var div = $('#messages')
            div.scrollTop(div.prop("scrollHeight"));
        }

        render() {
            return <div id="messages" style={{
                display: experimentState.application_state === ApplicationState.APP_CHAT?  "flex" : "none",
                flexDirection: "column",
                height: "500px",
                overflow: "auto",
                margin: "2px 0 5px 0",
                overflowY: "hidden",

            }}>
                {experimentState.messages.filter(({message}) => experimentState.experimentParams.admin || message !== "Has finished instruction Fase 3").map(({message, user, type, question_id, run_id, now}, idx) => {
                    if (type === "question" && experimentState.experimentParams.admin === false) {
                        message = `Vraag ${run_id+1}: ${this.props.chatQuestions[run_id][2]}`
                    } else if (type === "question") {
                        message = `${run_id+1}. Question ${question_id} was asked to the participant: ${this.props.chatQuestions[run_id][1]}`
                    }
                    let nextTime = (experimentState.messages.length > idx+1)? (now + this.timeout * 1000) > experimentState.messages[idx+1].now : false
                    let prevSame = idx && (experimentState.messages[idx - 1].user === user)
                    let nextSame = (idx + 1 < experimentState.messages.length) && (experimentState.messages[idx+1].user === user)
                    return <Message key={idx} message={message} user={user} nextSame={nextSame} prevSame={prevSame} type={type} start={now} now={this.state.now} timeout={this.timeout} nextTime={nextTime}
                                    idx={idx}>{idx} - {message}</Message>;
                })}
            </div>;
        }
    });

export default MessagesView;